module.exports = __webpack_public_path__ + "media/images/flags/ZA-4de46afa6c100ca34efe29c8480e37a4.svg";